import { SetStateAction, useEffect, useRef, useState } from "react";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";

import "moment/locale/pt-br";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faExchangeAlt,
    faFilter,
    faHistory,
    faTimes,
    faTrash,
    faUser,
    faUserTimes,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../../../Components/Table";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

import InternalError from "../../../Errors/InternalError";
import {
    IAtendimentoClienteRequest,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";

import { useUserInfor } from "../../../../Context/User";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ListarSubCategoriaController } from "../../../../Controllers/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaControllers";

import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { ACESSOS } from "../../../../Routes/Acessos";
import Select from "react-select";
import { ListarEtapasController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import StorageManagerCapys from "../../../../Tools/Storage";

import {
    IAtendimentoVendas,
    IAtendimentoVendasRequest,
} from "../../../../Interfaces/Vendas/GestaoAtendimentos/AtendimentosVendas";
import {
    ExportarExcelAtendimentosVendasController,
    ListarAtendimentosVendasController,
    ListarAtendimentosVendasTransferirController,
} from "../../../../Controllers/Vendas/GestaoAtendimentos/GestaoAtendimentosVendas";
import { AtendimentoV2 } from "../../../../Components/CardsPages/AtendimentoV2";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import TransferirTodosAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import HistoricoCardPage from "../../../../Components/CardsPages/Historico";
import TransferirAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirAtendimento";
import Swal from "sweetalert2";
import {
    ExcluirAtendimentoController,
    RemoverAtendimentoDoUsuarioController,
} from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { AtenderAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import HTMLRemover from "../../../../Components/Utils/HTMLRemover";
import { IFiltroAtendimentos } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import UnForm from "../../../../Components/Form";
import { FormProvider } from "antd/lib/form/context";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import SelectCategoriaAtendimento from "../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IPropsTableChange } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
// import { Switch } from "../../../../Components/CardsPages/Forms/Switch";

interface IAtendimentosVendasProps {
    atendimento: TModoGestaoAtendimento;
    filter?: IFiltroAtendimentos | undefined;
}
interface IFilterFormDataInterface {
    DT_INICIAL_IN?: string;
    DT_INICIAL_FN?: string;
    DT_FINAL_IN?: string;
    DT_FINAL_FN?: string;
    DS_STATUS_CASO?: string;
    ID_EMPREENDIMENTO?: number | string;
    ID_UNIDADE?: number;
    ID_CASO?: number;
    FL_ANDAMENTO?: number;
    ID_USUARIO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_CATEGORIA_ATENDIMENTO?: number[];
    ID_SUBCATEGORIA?: number;
    ID_CONTA: number;
    ID_ACOMPANHAMENTO?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO?: string[] /* array de arrays 'stringados' - ['8', '12,15,37', '38, 99'] */;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS?: number;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
}

const filtroInicial = {
    ID_CONTA: 0,
    ID_ACOMPANHAMENTO: 0,
    DS_STATUS_CASO: "Aberto",
};

function AtendimentosVendas(props: IAtendimentosVendasProps) {
    moment.locale("pt-br");
    const tipoAtendimento =
        props.atendimento === "USUARIO" ||
        props.atendimento === "ACOMPANHAMENTO"
            ? "MEUS"
            : props.atendimento;
    const filtroGestaoStorage =
        new StorageManagerCapys<IAtendimentoClienteRequest>(
            `FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE_${tipoAtendimento}`,
            "session"
        );

    const { setPage, setFilter, filter } =
        usePaginationFilter<IAtendimentoClienteRequest>();

    const FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE = filtroGestaoStorage.get();

    const [lstAtendimentos, setLstAtendimento] = useState<
        Array<IAtendimentoVendas>
    >([]);

    const [totalPaginas, setTotalPaginas] = useState(1);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(false);
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [idEmpreendimentoOption, setIdEmpreendimentoOption] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);
    const [categoriaAtendimento, setCategoriaAtendimento] = useState<number[]>(
        []
    );

    const { id } = useModuloInfo();

    const { UserInfor } = useUserInfor();

    const FormMethods = useForm<IFilterFormDataInterface>();
    const { reset, control, setValue } = FormMethods;

    const { value: lstEtapas } = useAsyncEffect(
        () => ListarEtapasController(ACESSOS.VENDAS.ID_MODULO ?? 0, 0),
        []
    );

    const { value: lstEmpreendimentos } = useAsyncEffect(() =>
        ListarEmpreendimentosController()
    );

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const lstEmpreendimentosOptions = lstEmpreendimentos?.map((e) => ({
        value: e.ID_EMPREENDIMENTO,
        label: e.DS_EMPREENDIMENTO,
    }));

    const selectInputRef = useRef<any>();

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
        setCategoriaAtendimento([]);
    };

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    //filtro
    // const filter = useRef<IAtendimentoClienteRequest>(
    //     filtroGestaoStorage.get() ?? filtroInicial
    // );

    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");
    // const [naoContem, setNaoContem] = useState<boolean>(true);

    function handleSearch(
        searchValue: string,
        newState: IPropsTableChange
        // contem: boolean
    ) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    ID_CONTA: 0,
                    PESQUISA: newState.searchText,
                    // FL_CONTEM: naoContem,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    useEffect(() => {
        let cancelRef = { cancel: false };
        updateAtendimentos(
            {
                ...filter,
                // FL_CONTEM: naoContem,
            },
            1,
            props.atendimento,
            cancelRef
        );

        return () => {
            cancelRef.cancel = true;
        };
    }, [props.atendimento, filter]);

    const updateAtendimentos = async (
        data: IAtendimentoVendasRequest,
        pagina: number,
        atendimento: TModoGestaoAtendimento,
        cancelRef?: { cancel: boolean }
    ) => {
        setLoading(true);
        await ListarAtendimentosVendasController(data, pagina, atendimento)
            .then((res) => {
                if (!cancelRef?.cancel) {
                    setLstAtendimento(res.ATENDIMENTOS_VENDAS);
                    setLoading(false);
                    setTotalPaginas(res.PAGINAS);
                }
            })
            .catch((err) => {
                if (!cancelRef?.cancel) {
                    setLoading(false);
                    setErr(true);
                }
            });
    };
    const handleDateChange = (formData: IFilterFormDataInterface) => {
        const filterFormData: IAtendimentoClienteRequest = {
            ID_CONTA: 0,
            DT_FINAL_IN:
                formData.DT_FINAL_IN && formData.DT_FINAL_IN?.length > 0
                    ? formData.DT_FINAL_IN
                    : undefined,
            DT_FINAL_FN:
                formData.DT_FINAL_FN && formData.DT_FINAL_FN?.length > 0
                    ? formData.DT_FINAL_FN
                    : undefined,
            DT_INICIAL_IN:
                formData.DT_INICIAL_IN && formData.DT_INICIAL_IN?.length > 0
                    ? formData.DT_INICIAL_IN
                    : undefined,
            DT_INICIAL_FN:
                formData.DT_INICIAL_FN && formData.DT_INICIAL_FN?.length > 0
                    ? formData.DT_INICIAL_FN
                    : undefined,
            DS_NOME_CONTA:
                formData.DS_NOME_CONTA && formData.DS_NOME_CONTA?.length > 0
                    ? formData.DS_NOME_CONTA
                    : undefined,
            DS_NOME_CONTATO:
                formData.DS_NOME_CONTATO && formData.DS_NOME_CONTATO?.length > 0
                    ? formData.DS_NOME_CONTATO
                    : undefined,
            DS_STATUS_CASO:
                formData.DS_STATUS_CASO && formData.DS_STATUS_CASO?.length > 0
                    ? formData.DS_STATUS_CASO
                    : undefined,
            ID_CASO:
                formData.ID_CASO && !isNaN(formData.ID_CASO)
                    ? formData.ID_CASO
                    : undefined,
            ID_CATEGORIA_ATENDIMENTO: categoriaAtendimento ?? [0],
            ID_SUBCATEGORIA:
                formData.ID_SUBCATEGORIA && formData.ID_SUBCATEGORIA > 0
                    ? formData.ID_SUBCATEGORIA
                    : undefined,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS:
                formData.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS,
            ID_EMPREENDIMENTO: idEmpreendimentoOption?.map(
                (empreendimento) => empreendimento.value
            ),
            FL_ANDAMENTO: formData.FL_ANDAMENTO,
            ID_USUARIO: formData.ID_USUARIO,
            ID_ACOMPANHAMENTO:
                formData.ID_ACOMPANHAMENTO && formData.ID_ACOMPANHAMENTO > 0
                    ? formData.ID_ACOMPANHAMENTO
                    : 0,
            ID_TIPO_CANAL_ATENDIMENTO:
                formData.ID_TIPO_CANAL_ATENDIMENTO &&
                formData.ID_TIPO_CANAL_ATENDIMENTO > 0
                    ? formData.ID_TIPO_CANAL_ATENDIMENTO
                    : 0,
            // FL_CONTEM: naoContem,
        };
        setFilter(filterFormData);
        filtroGestaoStorage.set(filterFormData);

        updateAtendimentos(
            {
                ...filter,
            },
            1,
            props.atendimento
        );
    };

    function rowAtendimento(cell: any, row: IAtendimentoVendas) {
        const atendimento = row;

        return (
            <AtendimentoV2
                ConfigAtendimento={{
                    ID_CASO: atendimento.ID_CASO || 0,
                    DS_CASO: "",
                    DS_CONTA: atendimento.InforCliente.DS_CONTA,
                    DS_ETAPA: atendimento.DS_ETAPA || "Sem Etapa",
                    NR_TELEFONE: atendimento.InforCliente.NR_TELEFONE,
                    BodyVendas: atendimento,
                }}
            />
        );
    }
    //tabela
    //`${row.PESO_ATENDIMENTO.HX_COR_PESO_ATENDIMENTO} !important`
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            isDummyField: true,
            formatter: rowAtendimento,
            headerClasses: "d-none",
        },
    ];
    const tableviewColumns: Array<ColumnDescription<IAtendimentoVendas>> = [
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Atendimento
                                </Tooltip>
                            }
                        >
                            <Link
                                to={ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK(
                                    row.ID_CASO || 0
                                )}
                                className="m-2 btn btn-icon btn-outline-info"
                            >
                                <i className="icon-xl far fa-eye"></i>
                            </Link>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "InforCliente.DS_CONTA",
            text: "Cliente",
            classes: "p-2 ws-nowrap",
            formatter: (_, row) => {
                return (
                    <>
                        <h6 className="mb-0"> {row?.InforCliente.DS_CONTA} </h6>
                        <span>
                            Telefone:{" "}
                            {row?.InforCliente.NR_TELEFONE[0]
                                ? row?.InforCliente.NR_TELEFONE[0]
                                : "-"}
                        </span>
                        <br />
                        <HTMLRemover
                            charLimit={30}
                            customLeiaMais="+"
                            customLeiaMenos="-"
                        >
                            {"Email: " + row?.InforCliente.DS_EMAIL}
                        </HTMLRemover>
                        <br />
                        <h6 style={{ fontSize: "14px" }}>
                            Origem Lead: {row?.InforCliente.DS_ORIGEM_LEAD}
                        </h6>
                    </>
                );
            },
        },
        {
            dataField: "InforCliente.DS_PRODUTO_OPORTUNIDADE",
            text: "Produto Oportunidade",
            classes: "p-2",
            formatter: (_, row) => (
                <div>
                    <div className="ws-nowrap">
                        {" "}
                        {row?.InforProdutosVendas.DS_PRODUTO_OPORTUNIDADE}
                    </div>
                </div>
            ),
        },
        {
            dataField: "DT_INICIO",
            text: "Data Inicial",
            formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
        },
        {
            dataField: "InforEquipeAtendimento.DS_USUARIO_RESPONSAVEL",
            text: "Atendente",
            formatter: (_, row) => {
                return (
                    <>
                        <h6 className="mb-0">
                            {row.InforEquipeAtendimento.DS_USUARIO_RESPONSAVEL}
                        </h6>

                        {row.InforEquipeAtendimento.DS_EQUIPE_VENDA_CORRETOR}
                    </>
                );
            },
        },
        {
            dataField: "DS_ETAPA",
            text: "Etapa",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex g-2 p-2">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="historico-tooltip">
                                Histórico do Caso
                            </Tooltip>
                        }
                    >
                        <button
                            className="btn btn-icon btn-outline-primary"
                            onClick={() => {
                                setModal({
                                    Component: () =>
                                        HistoricoCardPage({
                                            ID_CASO: row.ID_CASO ?? 0,
                                        }),
                                    headerComponent: "Históricos",
                                    IconHeader: faHistory,
                                    collapseForm: true,
                                    size: "lg",
                                });
                                setShow(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faHistory} />
                        </button>
                    </OverlayTrigger>
                    <div>
                        {UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                        ) && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="transferir-tooltip">
                                        Transferir Atendimento
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-warning"
                                    onClick={() => {
                                        setModal({
                                            Component: () => (
                                                <TransferirAtendimento
                                                    ID_CASO={row.ID_CASO ?? 0}
                                                    ID_TIPO_CASO={
                                                        ACESSOS.REPASSE
                                                            .ID_MODULO
                                                    }
                                                    setShow={setShow}
                                                    update={() => {
                                                        updateAtendimentos(
                                                            filter ?? {},
                                                            1,
                                                            props.atendimento
                                                        );
                                                    }}
                                                    ID_USUARIO={
                                                        row.ID_USUARIO_RESPONSAVEL
                                                    }
                                                    ID_USUARIO_ACOMPANHAMENTO={
                                                        row.ID_USUARIO_ACOMPANHAMENTO
                                                    }
                                                />
                                            ),
                                            IconHeader: faExchangeAlt,
                                            headerComponent:
                                                "Transferir Atendimento",
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                </button>
                            </OverlayTrigger>
                        )}
                    </div>
                    {!row.InforEquipeAtendimento.DS_USUARIO_RESPONSAVEL ? (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="atender-tooltip">Atender</Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-success"
                                onClick={() => {
                                    AtenderAtendimentoController(
                                        row.ID_CASO ?? 0
                                    ).then(() =>
                                        updateAtendimentos(
                                            {
                                                ...filter,
                                            },
                                            1,
                                            props.atendimento
                                        )
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon={faUser} />
                            </button>
                        </OverlayTrigger>
                    ) : (
                        <div>
                            {UserInfor.FUNCOES.some(
                                (f) =>
                                    f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="remover-tooltip">
                                            Remover Atendente
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-danger"
                                        onClick={() => {
                                            Swal.fire({
                                                title: `Deseja remover o vínculo de ${row.InforEquipeAtendimento.DS_USUARIO_RESPONSAVEL} a este atendimento?`,
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    RemoverAtendimentoDoUsuarioController(
                                                        row.ID_CASO ?? 0
                                                    ).then(() => {
                                                        updateAtendimentos(
                                                            filter ?? {},
                                                            1,
                                                            props.atendimento
                                                        );
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faUserTimes} />
                                    </button>
                                </OverlayTrigger>
                            )}
                        </div>
                    )}
                    {UserInfor.FUNCOES.some(
                        (f) => f.NM_FUNCAO === "ADM_EXCLUIR_CASO"
                    ) && (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="historico-tooltip">
                                    Excluir Atendimento
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-dark"
                                onClick={() => {
                                    Swal.fire({
                                        title: `Deseja excluir esse Atendimento? <br/> <br/> Caso: ${row.ID_CASO}`,
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            ExcluirAtendimentoController(
                                                row.ID_CASO ?? 0,
                                                UserInfor.ID_USUARIO ?? 0
                                            ).then(() => {
                                                updateAtendimentos(
                                                    filter ?? {},
                                                    1,
                                                    props.atendimento
                                                );
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </OverlayTrigger>
                    )}
                </div>
            ),
        },
    ];

    return (
        <>
            {err ? (
                <InternalError />
            ) : (
                <div className="card card-custom">
                    <div className="card-body mt-n2 table-responsive">
                        <Table
                            columns={atendimentoColumns}
                            data={lstAtendimentos}
                            keyField="ID_CASO"
                            onTableChange={(_type, newState) => {
                                const state = newState as IPropsTableChange;

                                if (state.searchText !== "") {
                                    handleSearch(
                                        state.searchText,
                                        state
                                        // naoContem
                                    );
                                    setPesquisaText(state.searchText);
                                } else if (pesquisaText.length > 0) {
                                    setFilter({
                                        ID_CONTA: 0,
                                        PESQUISA: state.searchText,
                                    });
                                } else {
                                    setPage(state.page);
                                }
                            }}
                            tableView={{
                                columns: tableviewColumns,
                                noSort: true,
                                sizePerPage: 10,
                                cancelYScroll: true,
                                defaultStyle: true,
                            }}
                            remote={{ pagination: true }}
                            totalPages={totalPaginas}
                            loading={loading}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Atendimento encontrado
                                </div>
                            )}
                            noHover
                            bordered={false}
                        />
                        <ModalComponent
                            show={show}
                            setShow={setShow}
                            ModalComponent={modal}
                        />
                    </div>
                </div>
            )}

            <StickyToolbar active={!!FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE}>
                <FormProvider {...FormMethods}>
                    <UnForm
                        className="form-group row"
                        handleSubmit={handleDateChange}
                    >
                        <div className="col-12 mt-3">
                            <label>Data Inicial</label>
                            <div className="row">
                                <div className="col-6">
                                    <UnForm.Input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_INICIAL_IN}
                                        name="DT_INICIAL_IN"
                                    />
                                </div>
                                <div className="col-6">
                                    <UnForm.Input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_INICIAL_FN}
                                        name="DT_INICIAL_FN"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>
                            <div className="row">
                                <div className="col-6">
                                    <UnForm.Input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_FINAL_IN}
                                        name="DT_FINAL_IN"
                                    />
                                </div>
                                <div className="col-6">
                                    <UnForm.Input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_FINAL_FN}
                                        name="DT_FINAL_FN"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Status do Caso</label>
                            <UnForm.Select
                                className="form-control"
                                name="DS_STATUS_CASO"
                                defaultValue={
                                    filter?.DS_STATUS_CASO ?? "Aberto"
                                }
                            >
                                <option></option>
                                <option>Aberto</option>
                                <option>Fechado</option>
                            </UnForm.Select>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                ref={selectInputRef}
                                options={lstEmpreendimentosOptions}
                                value={idEmpreendimentoOption}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    setIdEmpreendimentoOption(
                                        e.map((value) => ({
                                            label: value.label,
                                            value: value.value,
                                        }))
                                    );
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Protocolo</label>
                            <UnForm.Input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={filter?.ID_CASO}
                            />
                        </div>
                        {props.atendimento === "GRUPO" &&
                            UserInfor.FUNCOES.some(
                                (f) => f.NM_FUNCAO === "ADM_GESTAO_CASO_GRUPO"
                            ) && (
                                <div className="col-12 mt-3">
                                    <label>Situação</label>
                                    <UnForm.Select
                                        className="form-control"
                                        name="FL_ANDAMENTO"
                                        defaultValue={filter?.FL_ANDAMENTO}
                                    >
                                        <option value={2}>Todos</option>
                                        <option value={1}>
                                            Em Atendimento
                                        </option>
                                        <option value={0}>
                                            Fila de Atendimento
                                        </option>
                                    </UnForm.Select>
                                </div>
                            )}
                        {props.atendimento !== "USUARIO" && (
                            <div className="col-12 mt-3">
                                <label>Atendente</label>
                                <UnForm.LazySelect
                                    className="form-control"
                                    name="ID_USUARIO"
                                    controller={ListarUsuariosController}
                                    filter={(u) => u.FL_ATIVO}
                                    getDS={(u) => u.DS_NOME}
                                    getKeyValue={(u) => u.ID_USUARIO}
                                    defaultValue={filter?.ID_USUARIO}
                                    setValue={setValue}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        )}
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                name="DS_NOME_CONTA"
                                defaultValue={filter?.DS_NOME_CONTA}
                            />
                        </div>
                        {/* <div className="col-12 mt-3">
                            <label>Contato</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                name="DS_NOME_CONTATO"
                            />
                        </div> */}
                        <div className="col-12 mt-3">
                            <label>Categoria de Atendimento</label>
                            <SelectCategoriaAtendimento
                                ID_MODULO={id}
                                setIdCategoria={(c) =>
                                    setCategoriaAtendimento(
                                        c as SetStateAction<number[]>
                                    )
                                }
                                filterTreeNode={(input, treeNode) =>
                                    treeNode?.props.title
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                showSearch
                                control={control}
                                value={categoriaAtendimento}
                                multiple
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <LazySelect
                                label={"Subcategoria"}
                                className={`form-control placeholder-dark-75`}
                                name="ID_SUBCATEGORIA"
                                registerOptions={{
                                    valueAsNumber: true,
                                }}
                                {...FormMethods}
                                defaultValue={filter?.ID_SUBCATEGORIA?.toString()}
                                controller={ListarSubCategoriaController}
                                getDS={(s) => s.DS_SUBCATEGORIA_ATENDIMENTO}
                                getKeyValue={(s) =>
                                    s.ID_SUB_CATEGORIA_ATENDIMENTO
                                }
                            >
                                <option value={0}></option>
                            </LazySelect>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <UnForm.Select
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS"
                                defaultValue={
                                    props.filter
                                        ?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS
                                }
                            >
                                <option></option>
                                {lstEtapas?.map((etapa) => (
                                    <option
                                        value={Number(
                                            etapa?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        )}
                                    >
                                        {
                                            etapa?.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    </option>
                                ))}
                            </UnForm.Select>
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                {...FormMethods}
                                defaultValue={
                                    props.filter?.ID_TIPO_CANAL_ATENDIMENTO
                                }
                                className="mb-4"
                                label="Canal de Atendimento"
                                name="ID_TIPO_CANAL_ATENDIMENTO"
                                controller={listarCanalAtendimento}
                                getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                                getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        {/* <div className={`col-12 mt-3 `}>
                            <label>Não contém</label>
                            <div className="d-flex justify-content-start">
                                <Switch
                                    color="success"
                                    labelPosition="top"
                                    type="checkbox"
                                    name="FL_CONTEM"
                                    onChange={(e) => {
                                        if (e.target.checked === true) {
                                            Swal.fire({
                                                title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Ok!",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                },
                                            });
                                            setNaoContem(false);
                                        } else {
                                            setNaoContem(true);
                                        }
                                    }}
                                    defaultChecked={false}
                                />
                            </div>
                        </div> */}
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    filtroGestaoStorage.remove();
                                    reset(filtroInicial);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>

                <TransferirTodosAtendimento
                    ID_TIPO_CASO={ACESSOS.VENDAS.ID_MODULO}
                    filter={filter}
                    setShow={setShow}
                    update={() => {
                        updateAtendimentos(
                            {
                                ...filter,
                            },
                            1,
                            props.atendimento
                        );
                    }}
                    controller={() =>
                        ListarAtendimentosVendasTransferirController(
                            {
                                ...filter,
                            },
                            props.atendimento
                        )
                    }
                />

                <ExportExcel
                    baixarExcelController={async () =>
                        ExportarExcelAtendimentosVendasController(
                            {
                                ...filter,
                            },
                            props.atendimento
                        )
                    }
                    nomeArquivo={"Atendimentos_Vendas"}
                />
            </StickyToolbar>
        </>
    );
}

export default AtendimentosVendas;
